// @ts-nocheck
import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { socket } from "../../../services/socket.io/socket.io.config";
import {
  JOIN_GROUP_CHAT,
  NEW_GROUP_MESSAGE_LISTEN,
  ON_ADDED_TO_GROUP_CHAT,
  ON_EDIT_GROUP_CHAT,
  ON_NEW_GROUP_CHAT,
  ON_REMOVED_FROM_GROUP_CHAT,
  UPDATE_CHAT_STATUS,
} from "./constants";
import { ALERT_DIALOG } from "../../../store/constants/auth";
import {
  ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE_GROUP_CHAT,
  ADDED_TO_GROUP_CHAT,
  ON_NEW_MESSAGE_GROUP_CHAT,
  REMOVED_FROM_GROUP_CHAT,
  UPDATE_GROUP_CHAT,
  UPDATE_GROUP_CHAT_STATUS_SUCCESS,
} from "../../../store/constants/groupMessaging";
import {
  fetchUnreadMsgChatRoomsCountAction,
  markMessagesAsReadAction,
} from "../../../store/actions/groupMessagingActions";
import {
  emitGroupChatMessagesDelivered,
  emitSocketEvent,
} from "../../../services/apiService";
import _ from "lodash";

const useGroupMessagingEvents = ({
  showNewActivityBtnHandler,
  global = false,
}) => {
  // react-router hooks start...
  const location = useLocation();
  // react-router hooks end...

  // redux hooks start...
  const dispatch = useDispatch();

  // selectors start...
  const auth = useSelector((store) => store.auth);
  const currentUserId = useSelector(
    (state) => state.auth.user?._id || state.user?.id,
  );
  const { chatRoomMessages, chatRooms, selectedChatRoom } = useSelector(
    (store) => store.groupMessaging,
  );
  // selectors end...
  // redux hooks end...

  // Handlers start...
  // emit handlers start...
  const joinChatRoomsHandler = async ({ chatRoomIds }) => {
    const response = await emitSocketEvent({
      event: JOIN_GROUP_CHAT,
      payload: {
        roomIds: chatRoomIds,
        token: auth?.userToken,
      },
    });

    if (response?.status === "failure") {
      // dispatch({
      //   type: ALERT_DIALOG,
      //   payload: {
      //     open: true,
      //     title: "Error!",
      //     message: "Some error occured in connecting to the server. Please reload the browser!"
      //   }
      // })
    }

    // if (socket.connected) {
    //   socket.emit(JOIN_GROUP_CHAT, {
    //     roomIds: chatRoomIds,
    //     token: auth?.userToken
    //   }, (response) => {
    //     console.log(response, "JOIN_CHAT");
    //     if (response?.status === "failure") {
    //       dispatch({
    //         type: ALERT_DIALOG,
    //         payload: {
    //           open: true,
    //           title: "Error!",
    //           message: "Some error occured in connecting to the server. Please reload the browser!"
    //         }
    //       })
    //     }
    //   });
    // }
  };
  // emit handlers end...

  // listen handlers start...
  const onNewGroupMessageHandler = (response) => {
    dispatch({
      type: ON_NEW_MESSAGE_GROUP_CHAT,
      payload: {
        auth,
        newMessage: response?.data,
      },
    });

    if (response?.success == true) {
      emitGroupChatMessagesDelivered({
        roomIds: _.isArray(response?.data)
          ? response?.data?.map((c) => ({ id: c?.chatId }))
          : [{ id: response?.data?.chatId }],
      });
    }

    if (response?.data?.chatId === selectedChatRoom?.data?._id) {
      if (showNewActivityBtnHandler) {
        showNewActivityBtnHandler();
      }
      dispatch(
        markMessagesAsReadAction({
          payload: {
            roomId: response?.data?.chatId,
          },
        }),
      );
    }
  };

  const onNewChatRoomHandler = (response) => {
    dispatch({
      type: ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE_GROUP_CHAT,
      payload: {
        newChatRoom: response,
        // newChatRoomFirstMessage: response?.messageData?.data
      },
    });
  };

  const onEditChatRoomHandler = (actionById, response) => {
    if (actionById !== auth?.userId) {
      dispatch({
        type: UPDATE_GROUP_CHAT,
        payload: {
          chatRoom: response,
        },
      });
    }
  };

  const onUpdateChatRoomStatusHandler = (response) => {
    if (response?.data?.userId === currentUserId) {
      dispatch({
        type: UPDATE_GROUP_CHAT_STATUS_SUCCESS,
        payload: {
          updatedChatRoom: response?.data,
          chatId: response?.data?.chatId,
        },
      });

      dispatch(fetchUnreadMsgChatRoomsCountAction());
    }
  };

  const onAddedToGroupChat = (
    addedParticipants,
    chatId,
    chatRoom,
    chatRoomMessages,
  ) => {
    if (addedParticipants?.includes?.(auth?.userId)) {
      dispatch({
        type: ADDED_TO_GROUP_CHAT,
        payload: {
          chatId: chatId,
          chatRoom,
          chatRoomMessages,
          // newChatRoomFirstMessage: chatId?.messageData?.data
        },
      });

      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Alert!",
          message: `You have been added to ${
            chatRoom?.groupName || chatRoom?.eventName
          }!`,
        },
      });
    }
  };

  // const getCurrentUserId = () => {

  //   const state = store.getState();
  //   return state.auth.user?._id || state.user?.id;
  // }
  const onRemovedFromGroupChatHandler = (
    removedParticipants,
    chatId,
    chatRoom,
  ) => {
    if (removedParticipants?.includes?.(auth?.userId)) {
      dispatch({
        type: REMOVED_FROM_GROUP_CHAT,
        payload: {
          chatId: chatId,
          chatRoom,
          // newChatRoomFirstMessage: chatId?.messageData?.data
        },
      });

      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Alert!",
          message: `You have been removed from ${
            chatRoom?.groupName || chatRoom?.eventName
          }!`,
        },
      });
    }
  };
  // listen handlers end...
  // Handlers end...

  React.useEffect(() => {
    if (!global || (global && location.pathname !== "/event/chat")) {
      socket.on(NEW_GROUP_MESSAGE_LISTEN, onNewGroupMessageHandler);
      socket.on(ON_NEW_GROUP_CHAT, onNewChatRoomHandler);
      socket.on(ON_EDIT_GROUP_CHAT, onEditChatRoomHandler);
      socket.on(UPDATE_CHAT_STATUS, onUpdateChatRoomStatusHandler);
      socket.on(ON_REMOVED_FROM_GROUP_CHAT, onRemovedFromGroupChatHandler);
      socket.on(ON_ADDED_TO_GROUP_CHAT, onAddedToGroupChat);
    } else {
      socket.off(NEW_GROUP_MESSAGE_LISTEN, onNewGroupMessageHandler);
      socket.off(ON_NEW_GROUP_CHAT, onNewChatRoomHandler);
      socket.off(ON_EDIT_GROUP_CHAT, onEditChatRoomHandler);
      socket.off(UPDATE_CHAT_STATUS, onUpdateChatRoomStatusHandler);
      socket.off(ON_REMOVED_FROM_GROUP_CHAT, onRemovedFromGroupChatHandler);
      socket.off(ON_ADDED_TO_GROUP_CHAT, onAddedToGroupChat);
    }

    return () => {
      socket.off(NEW_GROUP_MESSAGE_LISTEN, onNewGroupMessageHandler);
      socket.off(ON_NEW_GROUP_CHAT, onNewChatRoomHandler);
      socket.off(ON_EDIT_GROUP_CHAT, onEditChatRoomHandler);
      socket.off(UPDATE_CHAT_STATUS, onUpdateChatRoomStatusHandler);
      socket.off(ON_REMOVED_FROM_GROUP_CHAT, onRemovedFromGroupChatHandler);
      socket.off(ON_ADDED_TO_GROUP_CHAT, onAddedToGroupChat);
    };
  }, [selectedChatRoom, location, global]);

  React.useEffect(() => {
    if (global && location.pathname === "/event/chat") {
      return;
    }

    if (chatRooms?.data?.length > 0) {
      joinChatRoomsHandler({
        chatRoomIds: chatRooms?.data?.map((chatRoom) => {
          return chatRoom?._id;
        }),
      });
    }
  }, [chatRooms?.data?.length, auth?.userToken, location, global]);

  return {
    //
  };
};

export default useGroupMessagingEvents;